import { CanDeactivateFn } from '@angular/router';

export type HasUnsavedChanges = {
  canDeactivate: () => boolean | Promise<boolean>;
};

export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  return component.canDeactivate();
};
